import { styleVariables, MathEnabledTextComponent } from '@lib/common';
import { Typography } from 'antd';
import styled from 'styled-components';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Paragraph = Typography.Paragraph,
    Title = Typography.Title;
var Layout = styled.div.withConfig({
  displayName: "pinned-sectioncomponent__Layout",
  componentId: "sc-1fj6p8e-0"
})(["display:flex;flex-direction:column;padding:32px 24px;background:", ";display:flex;"], styleVariables.colors.gray1);
var StyledHeader = styled.div.withConfig({
  displayName: "pinned-sectioncomponent__StyledHeader",
  componentId: "sc-1fj6p8e-1"
})(["display:flex;justify-content:start;align-items:center;margin-bottom:24px;"]);
var Description = styled(Paragraph).withConfig({
  displayName: "pinned-sectioncomponent__Description",
  componentId: "sc-1fj6p8e-2"
})(["&.ant-typography{margin-top:16px;margin-bottom:0;font-style:normal;font-weight:400;font-size:16px;line-height:24px;color:", ";}"], styleVariables.colors.gray13);
var StyledTitle = styled(Title).withConfig({
  displayName: "pinned-sectioncomponent__StyledTitle",
  componentId: "sc-1fj6p8e-3"
})(["&.ant-typography{margin-bottom:0;font-style:normal;font-size:24px;line-height:40px;color:", ";}"], styleVariables.colors.gray13);
var StyledLabelSection = styled.div.withConfig({
  displayName: "pinned-sectioncomponent__StyledLabelSection",
  componentId: "sc-1fj6p8e-4"
})(["color:", ";font-style:normal;font-weight:600;font-size:16px;line-height:24px;border-radius:12px;padding:10px;background-color:", ";"], styleVariables.colors.gray1, styleVariables.colors.blue3);
var Score = styled.label.withConfig({
  displayName: "pinned-sectioncomponent__Score",
  componentId: "sc-1fj6p8e-5"
})(["font-style:normal;font-weight:400;font-size:16px;line-height:24px;padding-left:12px;color:", ";"], styleVariables.colors.gray10);
export var PinnedSectionComponent = function PinnedSectionComponent(_ref) {
  var section = _ref.section,
      sectionIndex = _ref.sectionIndex,
      totalScore = _ref.totalScore,
      label = _ref.label,
      hideScore = _ref.hideScore;
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsxs(StyledHeader, {
      children: [/*#__PURE__*/_jsxs(StyledLabelSection, {
        children: [label.section, " ", sectionIndex + 1]
      }), !hideScore && /*#__PURE__*/_jsxs(Score, {
        children: [totalScore, " ", label.score]
      })]
    }), /*#__PURE__*/_jsx(StyledTitle, {
      level: 2,
      children: section.title
    }), /*#__PURE__*/_jsx(Description, {
      children: /*#__PURE__*/_jsx(MathEnabledTextComponent, {
        value: section.description
      })
    })]
  });
};